module.exports = __webpack_public_path__ + "img/my_qrcode_ins_us.cc65ab8.png";